import type { FaireProductEntity } from "../../entity_types/product";

export const p_my2qwbfzeu: FaireProductEntity = {
  token: "p_my2qwbfzeu",
  type: "product",
  name: "RAPTURE Blackberry Balsamic Vinegar",
  brandToken: "b_1khrj7y7",
  brandName: "Brightland",
  imageUrl:
    "https://cdn.faire.com/fastly/b65ecf2e842ff818e1371803d92155d43f95b58fa5183ce73ceb8bf9977018d7.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3928887bdea2745b2001cc29f5e2eccecafd15e907ccf6a5406f6387d983593f.jpeg",
    "https://cdn.faire.com/fastly/29e4f79188a08d0465899c767727f6948632aa1a0f82457300cfeca09b0e82af.jpeg",
    "https://cdn.faire.com/fastly/ee1ed2325835d64aa752859990a90dd4589239ca8aa34be076801454b6592dfb.jpeg",
  ],
  priceDollars: 13.2,
  description:
    "RAPTURE is a raw balsamic vinegar that is double fermented with California zinfandel grapes and ripe Triple Crown blackberries. RAPTURE is lovingly crafted on a nutrient-dense, family-run farm in California’s Central Coast. Enjoy with salads, marinades, mozzarella and tomato, crusty bread, BBQ, peaches and summer fruit. Pair it with Brightland's AWAKE, ARDOR, ALIVE. \n\nRAPTURE comes in a 200 mL recyclable glass bottle. \n\nIngredients: Balsamic vinegar, pure cane sugar, blackberries\n\n***\n\n“The company is committed to sustainability and social consciousness. The organic grapes used for the vinegars are grown in Northern California, and both varieties are double-fermented and distilled on a family farm on the Central Coast.” - The New York Times\n\n“These new balsamic and champagne vinegars are raising the bar.” - Food and Wine\n\nNote: $20 flat rate for shipping per case (no matter where it's going).\n",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:52.934Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
